module.exports = __webpack_public_path__ + "static/img/faq_banner_wap.1b7d9d42.png";